import { Survey } from './survey.model';
import { SimpleQuestionMapper, ComplexQuestionMapper } from 'app/question';

export class SurveyMapper {
  public static map(surveyData: any): Survey {
    if (!surveyData) {
      return null;
    }

    if (!Array.isArray(surveyData.questions)) {
      surveyData.questions = [];
    }

    return new Survey(
        surveyData.id,
        surveyData.name,
        surveyData.type,
        surveyData.createdAt,
        surveyData.randomizedQuestions,
        surveyData.reanswerEnabled,
        surveyData.questions
          .map(question => SurveyMapper.checkQuestionModel(question))
          .filter(question => question !== null)
          .sort((firstQuestion, secondQuestion) => firstQuestion.order - secondQuestion.order),
        surveyData.description,
        surveyData.questionsPerPage,
        surveyData.deletable,
        surveyData.editable,
        surveyData.sessionsTotal
      );
  }

  public static checkQuestionModel(question: any): any {
    if (undefined !== question.questions) {
      return ComplexQuestionMapper.map(question);
    }

    return SimpleQuestionMapper.map(question);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/survey/survey.mapper.ts